import React from 'react'
import { StyledRadioButton } from './styles/styled-radio-button.style'

const RadioButton = ({
	id,
	datafor,
	onClick,
	children,
	isActive,
	noBorder,
	className,
	sourceCall
}) => (
	<StyledRadioButton
		id={id}
		className={className}
		data-for={sourceCall === 'ticketsale' ? datafor : ''}
		data-tip
		noBorder={noBorder}
		isActive={isActive}
		onClick={() => {
			onClick && onClick()
		}}>
		{children}
	</StyledRadioButton>
)

export default RadioButton
